<template>
  <v-card>
    <v-card-title class="justify-end">
      <div class="search-box">
        <v-text-field
          append-icon="mdi-magnify"
          placeholder="ค้นหา"
          outlined
          :value="keyword"
          @input="changeKeyword"
        ></v-text-field>
      </div>
    </v-card-title>

    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr class="header-color">
          <th class="text-center">วันที่และเวลาที่ดาวน์โหลด</th>
          <th class="text-center">ชื่อเอกสาร</th>
          <th class="text-center">จำนวนไฟล์</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="docsDownloaded in docsDownloadedList" :key="docsDownloaded.id">
          <td class="text-center">{{ docsDownloaded['timeCreated'] }}</td>
          <td>{{ docsDownloaded['name'] }}</td>
          <td class="text-center">{{ docsDownloaded['countXml'] }}</td>
          <td class="text-center">
            <v-btn text color="#6ec39b" :href="docsDownloaded['zipUrl']">
              <img
                src="/images/icons/icon_download_xml.svg"
                style="max-height: 26px; max-width: 26px"
                class="mr-2"
              />
              <b>ดาวน์โหลด XML</b>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-progress-linear indeterminate color="green" :active="loading"></v-progress-linear>

  </v-card>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      // loading: false
    }
  },
  created() {
    this.query();
  },
  beforeDestroy() {
    this.$store.dispatch('docsDownloadedByCompany/getDocDownloadListUnsubscribe')
  },
  computed: mapState({
    docsDownloadedList: state => state.docsDownloadedByCompany.list,
    loading: state => state.docsDownloadedByCompany.loading,
    keyword: state => state.docsDownloadedByCompany.keyword,
  }),
  methods: {
    query: function () {
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch('docsDownloadedByCompany/getList', {id: companyId})
      }
    },
    changeKeyword: function (keyword) {
      let companyId = this.$route.params.companyId
      if (companyId) {
        this.$store.dispatch('docsDownloadedByCompany/updateKeyword', {id: companyId, keyword: keyword})
        this.query();
      }
    },
  },
}
</script>

<style lang="scss">
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
  border-radius: 10px !important;
  border-color: #c4c4c4;;

  margin-top: 5px;
  margin-bottom: 5px;
}

.search-box {
  width: 250px;
  height: 60px;
}

.header-color {
  background-color: #ebebeb;
}
</style>
